import { ShieldCheck, Sparkles, MonitorSmartphone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../components/ui/dialog";

// Shown once per session when a customer opens a service whose library is still being built out (PPF, Navigation Screen).
const COPY = {
  PPF: { title: "Paint Protection Film — Library in Progress", what: "PPF patterns", items: "kits", go: "Continue to PPF", Icon: ShieldCheck, tone: "#f5a524", text: "#f5c542" },
  Interior: { title: "Navigation Screen — Library in Progress", what: "navigation screen patterns", items: "screens", go: "Continue to Navigation Screen", Icon: MonitorSmartphone, tone: "#3ecf8e", text: "#7fe3b4" },
};

export const PpfNoticeDialog = ({ open, service = "PPF", onClose, onRequest }) => {
  const c = COPY[service] || COPY.PPF;
  const key = service.toLowerCase();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="panel3d max-w-md bg-[#121824] text-[#e8e9ec]" style={{ borderColor: `${c.tone}4d` }} data-testid={`${key}-notice-dialog`}>
        <DialogHeader className="items-center text-center sm:text-center">
          <span className="mx-auto mb-1 flex h-12 w-12 items-center justify-center rounded-full" style={{ background: `${c.tone}26`, color: c.text }}><c.Icon className="h-7 w-7" /></span>
          <DialogTitle className="text-[17px]" data-testid={`${key}-notice-title`}>{c.title}</DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed text-[#b4b9c1]" data-testid={`${key}-notice-message`}>
            Thank you for your interest in {c.what}. Our team is actively adding vehicle patterns to this library, and new {c.items} are published every week.
            <span className="mt-2 block">If there is a vehicle you need, please submit a request from your dashboard and mark it as <span className="font-semibold" style={{ color: c.text }}>High Priority</span>. We will prioritize it and notify you as soon as the templates are available.</span>
          </DialogDescription>
        </DialogHeader>
        <div className="mt-1 flex flex-col gap-2 sm:flex-row">
          <button type="button" data-testid={`${key}-notice-request-btn`} onClick={onRequest} className="btn-red flex flex-1 items-center justify-center gap-1.5"><Sparkles className="h-4 w-4" /> Request a vehicle</button>
          <button type="button" data-testid={`${key}-notice-close-btn`} onClick={onClose} className="btn flex-1 justify-center">{c.go}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
